import type { ServiceItem } from '@/types/interfaces/service-item'

export function getServiceHref(service: ServiceItem): string | undefined {
    const skuName = service.skuName
    const skuId = service.skuId?.toString() || service.id?.toString()
    return skuName && skuId ? `/s/${skuName}/${skuId}` : undefined
}

